<template>
  <q-avatar class="q-mr-sm">
    <img v-if="src" alt="company logo" :src="src" />
    <img
      v-else
      src="@/assets/icons/personal.png"
      alt="default profile picture"
      style="filter: grayscale(100%)"
    />
  </q-avatar>
</template>
<script>
export default {
  name: 'Avatar',
  props: {
    src: {
      type: String,
      default: null,
    },
  },
};
</script>
